import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionComponent } from './section.component';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [SectionComponent],
  imports: [CommonModule, MatDividerModule],
  exports: [SectionComponent],
})
export class SectionModule {}
